import { JoinCampaignOption } from '../types/JoinCampaignOffer';

/** Joins the campaign lists, offering a campaign several groups share (say, a chosen one and the default) once. */
export const joinCampaignsToOffer = (lists: JoinCampaignOption[][]): JoinCampaignOption[] => {
  const campaigns = new Map<string, JoinCampaignOption>();
  lists.flat().forEach(c => {
    if (!campaigns.has(c.id)) campaigns.set(c.id, c);
  });
  return [...campaigns.values()];
};
